// Runtime configuration, fetched from /config.json rather than baked into the
// build: one build serves local dev (public/config.json) and every AWS stage (the
// CDK stack writes config.json next to the app on deploy).

export type AuthConfig =
  | { mode: 'dev' }
  | { mode: 'cognito'; signInUrl: string; clientId: string };

export interface AppConfig {
  /** '' when the API is on the same origin (the Vite dev proxy). */
  apiUrl: string;
  auth: AuthConfig;
}

let current: AppConfig | undefined;

export async function loadConfig(): Promise<AppConfig> {
  const res = await fetch('/config.json', { cache: 'no-store' });
  if (!res.ok) throw new Error(`Could not load /config.json (${res.status})`);
  current = (await res.json()) as AppConfig;
  current.apiUrl = current.apiUrl.replace(/\/$/, '');
  return current;
}

export function config(): AppConfig {
  if (!current) throw new Error('config() called before loadConfig()');
  return current;
}
